import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';

import { AuthInterceptor } from '../auth/@shared/auth.interceptor';
import { LanguageInterceptor } from './language.interceptor';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
    },
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
    },
  ],
})
export class CoreModule {
  public static injector: Injector;

  constructor(injector: Injector) {
    CoreModule.injector = injector;
  }
}
